export default __webpack_public_path__ + "static/media/ic_books.a7ebd97a.svg";